export default __webpack_public_path__ + "static/media/extension.986cb4f2.gif";